import { render, staticRenderFns } from "./ConfirmAssignVoucherModal.vue?vue&type=template&id=24e0024e&scoped=true&"
import script from "./ConfirmAssignVoucherModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmAssignVoucherModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAssignVoucherModal.vue?vue&type=style&index=0&id=24e0024e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e0024e",
  null
  
)

export default component.exports